export interface VariantPricing {
    currency?: string;
    goodsStatus?: string;
    id: string;
    mov?: number;
    moq?: number;
    supplyType?: string;
    shippingDate?: string;
    preOrderShippingDate?: string;
    promotionDescription?: string;
    promotionTextColor?: string;
    fullPackageOnly?: boolean;
    volumeDiscounts?: unknown;
    prePaymentPercentage?: number;
    isLimitedTimeOffer?: boolean;
    isDecoded?: boolean;
    isDamagedPackaging?: boolean;
    isShortBbd?: boolean;
}

export interface VariantStockLevel {
    stockOnHand: number;
    stockAllocated: number;
}

export interface PricingProductInfo {
    minQ?: number | null;
    maxQ?: number | null;
}

export interface PricingVariant {
    moq?: number;
    pricingProduct?: PricingProductInfo | null;
}

export interface TableVariant {
    id: string;
    priceWithTax: number;
    moq?: number;
    preOrderShippingDate?: string;
    pricing?: VariantPricing;
    stockLevels?: VariantStockLevel[];
    pricingProduct?: PricingProductInfo;
}

export interface SearchVariant {
    id: string;
    supplierId: number;
    priceWithTax: number;
    qty?: number;
    moq?: number;
    mov?: number;
    quantityPerBox?: number | null;
    supplyType?: string;
    shippingDate?: string;
    preOrderShippingDate?: string;
    promotionDescription?: string;
    pricingProduct?: PricingProductInfo;
    pricing?: VariantPricing;
}

export interface SearchProduct {
    productId: string;
    slug: string;
    productName: string;
    variants: SearchVariant[];
    cheapestVariant?: SearchVariant;
    customProductMappings?: {
        quantityPerBox?: number | null;
        gtin?: string;
        brand?: string;
    };
}

export const SUPPLY_TYPE_PRE_ORDER = "pre-order" as const;
export const DEFAULT_MOQ = 1 as const;
export const DEFAULT_QUANTITY = 0 as const;
